import React from 'react';

import PageTitle from '../common/PageTitle';
import SingleImport from '../common/SingleImport';
import { useAutoTranslation } from '../../helpers/useAutoTranslation';

const OrdersSingleImportPage = (props) => {
  const { t } = useAutoTranslation();

  return (
    <>
      <PageTitle title={t('Импорт заказов')} />

      <SingleImport
        templateType="ORDER"
        templateFileName="OrderTemplate"
        successMessage={t('Задание на импорт заказов создано успешно')}
        successRoute="/orders-import"
        errorMessage={t('Ошибка создания задания на импорт заказов')}
      />
    </>
  );
};

export default OrdersSingleImportPage;
